import * as React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { ThunkDispatch } from "../../../types/redux";
import {
  ClientDimension,
  ClientDimensionInstance as ClientDimensionInstanceModal,
} from "../../../types/models";
import { Flex } from "@rebass/grid";
import {
  Button,
  ButtonGroup,
  InputGroup,
  Intent,
  Text,
  Classes,
  Icon,
} from "@blueprintjs/core";
import { trim } from "ramda";
import {
  createClientDimensionInstanceData,
  getClientDimensionsData,
} from "src/store/modules/client_dimensions";
import { DEFAULT_CLIENT_DIMENSION_INSTANCE_NAME } from "./ClientDimensionColumn";
import Toaster from "src/components/molecules/Toaster";
import { MAX_INSTANCE_NAME_LENGTH } from "src/constants/validation";

interface IProps {
  dispatch: ThunkDispatch;
  dimension: ClientDimension;
  dimensionInstance: ClientDimensionInstanceModal;
  validateName: (name: string) => boolean;
  isHighlighted: boolean;
  clientId: number;
  addNewDimInstance: (instance: ClientDimensionInstanceModal) => void;
  onDeleteInstanceMappings?: (dimensionInstanceId: number) => void;
  removeDimInstance: () => void;
  toggleSideBar: (dimensionInstance: ClientDimensionInstanceModal) => void;
}

export class ClientDimensionInstance extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      errorMsg: "",
      instanceName: this.props.dimensionInstance.Name,
      isEditing:
        this.props.dimensionInstance.Name ===
        DEFAULT_CLIENT_DIMENSION_INSTANCE_NAME,
      isDeleting: false,
      isSaving: false,
      value: this.props.dimensionInstance.Name,
    };
  }

  public componentDidUpdate() {
    if (
      this.props.dimensionInstance.Name ===
        DEFAULT_CLIENT_DIMENSION_INSTANCE_NAME &&
      !this.state.isEditing
    ) {
      this.setState({ instanceName: "", isEditing: true });
    }
  }

  public render() {
    return (
      <StyledButton
        style={this.getInstanceStateStyles()}
        onClick={this.state.isEditing ? undefined : this.handleClick}
      >
        {this.state.isEditing ? (
          <this.InstanceEditing />
        ) : (
          <Flex
            justifyContent={"space-between"}
            width={1}
            css={{ padding: "5px 16px" }}
          >
            {this.props.dimensionInstance.Name}

            <Icon
              icon="flow-branch"
              onClick={() =>
                this.props.toggleSideBar(this.props.dimensionInstance)
              }
              style={{ cursor: "pointer", marginTop: "-10px" }}
            />
          </Flex>
        )}
      </StyledButton>
    );
  }

  private getInstanceStateStyles = () => {
    let styles = { opacity: 1 };

    if (this.props.isHighlighted) {
      styles = Object.assign(styles, {
        opacity: 1,
        boxShadow:
          "0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px 0 rgba(16, 22, 26, 0.2), 0 0 0 3px #48aff0",
      });
    }

    return styles;
  };

  private handleNameChange = (event: any) => {
    this.setState({ instanceName: trim(event.target.value) });
  };

  private handleEdit = (event: any) => {
    event.preventDefault();

    if (this.props.validateName(this.state.instanceName)) {
      this.setState({ isSaving: true });
      this.props
        .dispatch(
          createClientDimensionInstanceData(
            this.props.clientId,
            this.props.dimension.id,
            this.state.instanceName
          )
        )
        .then((data) => {
          this.props.addNewDimInstance(data);
          this.setState({ isEditing: false, isSaving: false });
          Toaster.show({
            message: "Dimension instance created successfully",
            intent: Intent.SUCCESS,
          });

          this.props.dispatch(
            getClientDimensionsData(this.props.clientId) as any
          );
        })
        .catch(() => {
          this.setState({ isSaving: false });
          Toaster.show({
            message: "Error creating dimension instance",
            intent: Intent.DANGER,
          });
        });
    } else {
      this.setState({ errorMsg: "An Instance already exists with this name." });
    }
  };

  private handleClick = () => {
    // const { dimension, dimensionInstance, dimensionInstanceSidebar } =
    //   this.props;
    // if (dimensionInstanceSidebar) {
    //   dimensionInstanceSidebar(dimensionInstance, dimension);
    // }
  };

  private handleInstanceDelete = () => {
    this.setState({ isEditing: false });
    this.props.removeDimInstance();
  };

  private InstanceEditing: React.FC = () => {
    return (
      <form onSubmit={this.handleEdit} style={{ width: "100%" }}>
        <Flex>
          <InputGroup
            type="text"
            onChange={this.handleNameChange}
            placeholder={"Instance Name"}
            required={true}
            autoFocus={true}
            fill
            maxLength={MAX_INSTANCE_NAME_LENGTH}
            defaultValue={`${
              this.props.dimensionInstance.Name !==
              DEFAULT_CLIENT_DIMENSION_INSTANCE_NAME
                ? this.props.dimensionInstance.Name
                : ""
            }`}
          />
          <ButtonGroup minimal={true}>
            <Button icon={"tick"} type="submit" loading={this.state.isSaving} />
            <Button
              icon={"trash"}
              loading={this.state.isDeleting}
              onClick={this.handleInstanceDelete}
              intent={Intent.DANGER}
            />
          </ButtonGroup>
        </Flex>
        <Text className={Classes.TEXT_SMALL} style={{color: 'red', padding: '6px 0'}}>{this.state.errorMsg}</Text>
      </form>
    );
  };
}

const StyledButton = styled.div`
  all: unset;
  cursor: pointer;
  box-sizing: border-box;
  background-color: white;
  border-radius: 3px;
  color: #5c7080;
  display: flex;
  font-size: 16px;
  margin-bottom: 16px;
  padding: 16px;
  width: 100%;
  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0),
    0 1px 1px rgba(16, 22, 26, 0.2);
  &:focus {
    outline: none;
  }
  &:hover {
    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1),
      0 2px 4px 0 rgba(16, 22, 26, 0.2), 0 0 0 3px rgba(72, 175, 240, 0.5);
  }
`;

export default connect()(ClientDimensionInstance);
